import { render } from "./moviesPage.vue?vue&type=template&id=61b80c5e&scoped=true"
import script from "./moviesPage.vue?vue&type=script&lang=js"
export * from "./moviesPage.vue?vue&type=script&lang=js"

import "./moviesPage.vue?vue&type=style&index=0&id=61b80c5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b80c5e"]])

export default __exports__